import React, { useState } from "react";

const initialStore = {
  guid: "",
  reference: "Loading...",
  googleurl: "",
  players: [],
  photos: [],
  actionReplays: [],
  loopcams: [],
  games: [],
  preview: [],
  parsedPlayers: [],
  newsfeed: [],
  teams: [],
  deleted: false,
};

export const Context = React.createContext();

const Store = ({ children }) => {
  const [state, setState] = useState(initialStore);

  return <Context.Provider value={[state, setState]}>{children}</Context.Provider>;
};

export default Store;
